import React, { useState, useEffect } from 'react';
import useTranslations from '../../../utils/useTranslations';
import FeaturesList from '../../../components/featuresList';
import ComparisonPanels from '../../../components/comparisonPanels';

import btHeroImgWebp from '../../../images/homepage/bt-screen-android-mobile.webp';
import btHeroImg from '../../../images/homepage/bt-screen-android-mobile.png';
import btHeroImgWebp2x from '../../../images/homepage/bt-screen-android-mobile@2x.webp';
import btHeroImg2x from '../../../images/homepage/bt-screen-android-mobile@2x.png';

import utHeroImgWebp from '../../../images/homepage/ut-screen-android-mobile.webp';
import utHeroImg from '../../../images/homepage/ut-screen-android-mobile.png';
import utHeroImgWebp2x from '../../../images/homepage/ut-screen-android-mobile@2x.webp';
import utHeroImg2x from '../../../images/homepage/ut-screen-android-mobile@2x.png';

import Logo from '../../../components/logo';
import backgrounds from '../../../components/backgrounds';

import { ANDROID_LINK_PRO, getAndroidLink } from '../../../utils/getAndroidLink';
import Seo from '../../../components/seo';

const btHeroImgAlt = 'Buy and download BitTorrent Pro for Android devices.';
const utHeroImgAlt = 'Buy and download µTorrent Pro for Android devices.';

const isBt = process.env.BRAND === 'bt';
const heroImgWebp = isBt ? btHeroImgWebp : utHeroImgWebp;
const heroImg = isBt ? btHeroImg : utHeroImg;
const heroImgWebp2x = isBt ? btHeroImgWebp2x : utHeroImgWebp2x;
const heroImg2x = isBt ? btHeroImg2x : utHeroImg2x;

const AndroidPro = (props) => {
    const { text, pageName } = props.pageContext;
    const [androidLinkPro, setAndroidLinkPro] = useState(ANDROID_LINK_PRO);
    const t = useTranslations(text);
    const isBt = process.env.BRAND === 'bt';

    const locale = props.pageContext.locale;
    const googlePlayButton = `/images/google-play-badges/google-play-badge-${locale}.png`;

    useEffect(() => {
        setAndroidLinkPro(getAndroidLink('pro'));
    }, []);

    return (
        <>
            <div className="top-section-container p-0 pt-md-3 background-noise-dark" style={backgrounds.darkCorners}>
                <div className="container text-dark py-2">
                    <div className="row text-center mt-4 mt-sm-0">
                        <div className="col-md-6 order-md-1 px-md-0 d-flex flex-column justify-content-center align-items-center">
                            <Logo
                                color={isBt ? 'black-bt' : 'black-classic-ut'}
                                tag="h1"
                                productName="Android Pro"
                                className="tw-mb-6"
                            />
                            <picture>
                                <source srcSet={`${heroImgWebp} 1x, ${heroImgWebp2x} 2x`} type="image/webp" />
                                <img
                                    srcSet={`${heroImg} 1x, ${heroImg2x} 2x`}
                                    src={heroImg}
                                    alt={isBt ? btHeroImgAlt : utHeroImgAlt}
                                    className="android-hero tw-mb-6 tw-block md:tw-hidden"
                                />
                            </picture>

                            <p className="text-size-24 text-spacing-1 font-weight-normal">
                                {t(`Get more out of the #1 Android torrent client.`)}
                            </p>
                            <ul className="product-hero-list mt-2">
                                <li>{t(`No ads.`)}</li>
                                <li>{t(`Battery saving features.`)}</li>
                                <li>{t(`Save data with automatic shutdown.`)}</li>
                            </ul>
                            <a
                                href={androidLinkPro}
                                id="product-android-pro"
                                className="index-mobile-google-play"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    className="google-play-button img-fluid"
                                    src={googlePlayButton}
                                    alt={
                                        isBt
                                            ? 'BitTorrent for Android Google Play Store badge'
                                            : 'µTorrent for Android Google Play Store badge'
                                    }
                                />
                            </a>
                        </div>
                        <div className="col-md-6 mt-5 order-md-2 d-flex justify-content-center align-items-center">
                            <picture>
                                <source srcSet={`${heroImgWebp} 1x, ${heroImgWebp2x} 2x`} type="image/webp" />
                                <img
                                    srcSet={`${heroImg} 1x, ${heroImg2x} 2x`}
                                    src={heroImg}
                                    alt={isBt ? btHeroImgAlt : utHeroImgAlt}
                                    className="hero-img android-hero tw-hidden md:tw-block"
                                />
                            </picture>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid position-relative overflow-hidden">
                <div className="bg-text-container bg-text-gray">{t(`FeaturesHeader`)}</div>
                <div className="container my-5 text-center z-2">
                    <p className="text-center font-weight-bold feature-list-title-2 mb-3">{t(`FeaturesHeader`)}</p>
                    <p className="text-center mb-5 text-size-24">
                        {t(`$brand Pro Torrent Downloader for Android Features`)}
                    </p>
                    <div className="index-features-list m-auto pb-5">
                        <FeaturesList text={text} pageName={pageName} />
                    </div>
                </div>
            </div>

            <div className="container-fluid position-relative overflow-hidden">
                <div className="bg-text-container bg-text-gray">{t(`Compare`)}</div>
                <div className="container mb-5 text-center">
                    <p className="text-center font-weight-bold feature-list-title-2 mb-3">{t(`Compare`)}</p>
                    <h2 className="text-center mb-5 text-size-24 font-weight-normal">
                        {t(`Compare Pro with $brand for Android Free`)}
                    </h2>
                </div>
                <ComparisonPanels
                    pageContext={{
                        text: text,
                        pageName: pageName,
                        isMac: true,
                    }}
                />
            </div>

            <div className="container mb-5">
                <div className="word-cloud font-weight-bold">
                    {isBt ? 'BitTorrent' : 'µTorrent'} <span className="font-weight-normal">Android Pro</span>
                    <span className="font-weight-bold">/</span> <br />{' '}
                    <span className="text-size-32">{t(`Product Tip`)}</span>
                </div>
            </div>

            <div className="container my-md-5 py-md-5">
                <div className="row mb-5 mb-md-5 pb-md-5">
                    <div className="col-md-4 text-md-right product-faq-question mb-3 mb-md-0">
                        {t(`Why Choose the Pro<br>Version of $brand<br><b>on Mobile?</b>`)}
                    </div>
                    <div className="offset-md-1 col-md-7 product-faq-answer">
                        {t(
                            `<b>Pro takes the most trusted Android torrent client</b> on the Google Play Store and adds several features to create a better $brand mobile experience. In addition to being ad-free, Pro allows you to stop torrenting when your battery hits a predefined level. You can also stop torrenting when your downloads have finished to save on your mobile data plan. If you’re a Pro user, you can contact customer support if you have questions about your Android torrent client.`
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default AndroidPro;

export const Head = ({ pageContext }) => <Seo pageContext={pageContext} />;
